export const BOOKING_STATUSES = {
	DELETED: 0,
	ACTIVE: 2,
}
export const BOOKING_TO_USER_STATUSES = {
	DELETED: 0,
	ACTIVE: 1,
}
